import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "./config";

export const useFetchQuotationDetail = (quotationId: number) => {
  return useQuery({
    queryKey: ["quotation-detail", quotationId],
    queryFn: () => axiosInstance.get(`quotations/${quotationId}`),
  });
};
